
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","d":"M5 7.5h7m-.5-6v3m-6-3v3m-2 10h10a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1h-10a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1Z"}})])
          )
        }
      }
    